/** Build a local destination from validated IDs, never from a supplied URL. */
export function partnershipNotificationRoute(data: unknown): string | null {
  if (!data || typeof data !== "object" || Array.isArray(data)) return null;
  const target = data as Record<string, unknown>;
  if (
    target.entityType !== "partnership" ||
    Object.keys(target).some(
      (key) => !["entityType", "partnershipId", "universityId"].includes(key),
    ) ||
    ![target.partnershipId, target.universityId].every(
      (id) => typeof id === "number" && Number.isSafeInteger(id) && id > 0,
    )
  )
    return null;
  return `/partnerships?institutionId=${target.universityId}`;
}
